<template>
  <div class="container__method-component-outline container__method-components">
    <span class="header__method-component" :class="`header__method-${mode}`">
      <b-img :src="iconCodiconBook" class="icon__codicon-book mr-2"> </b-img>
      <h5 class="font-weight-bold m-0">Method Components</h5>
    </span>
    <div v-if="methodComponents">
      <ul class="list__method-outline text-primary mb-0">
        <li
          v-for="(item, index) in methodComponents"
          :id="`outline-item-${item.id}`"
          :key="index"
          class="item__method-outline"
          :class="{ 'selected-item__method-outline': index === $selectedIndex }"
          @click="onChangeSelectItem(index)"
        >
          {{ item.title }}
        </li>
      </ul>

      <div v-if="isOwner && !isPublished" id="tooitip-disabled-wrapper">
        <b-button
          id="button__add-method"
          class="w-100 button__add-method button__add"
          variant="outline-primary"
          :disabled="isEditing"
          @click="addMethodOutline"
        >
          <font-awesome-icon
            class="icon__add"
            :icon="{ prefix: 'fas', iconName: 'plus' }"
            size="xs"
          />
          Add
        </b-button>

        <b-tooltip
          v-if="isEditing"
          :placement="isLargeScreen ? `right` : `bottom`"
          triggers="hover"
          target="tooitip-disabled-wrapper"
          custom-class="tooltip__add-method"
          variant="light"
        >
          New topics can be added after the existing topic is finished.</b-tooltip
        >
      </div>
    </div>
  </div>
</template>

<script>
import codiconBookSvg from '@/assets/icon-method-component/codicon-book.svg';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon
  },
  model: {
    prop: 'selectedIndex',
    event: 'update:selectedIndex'
  },
  props: {
    methodComponents: {
      type: Array,
      default: () => []
    },
    selectedIndex: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ['create', 'view', 'edit'].includes(value)
    },
    isPublished: {
      type: Boolean,
      default: false
    },
    isOwner: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconCodiconBook: codiconBookSvg,
      methodOutline: [],
      isLargeScreen: false
    };
  },
  computed: {
    $selectedIndex: {
      get() {
        return this.selectedIndex;
      },
      set(newIndex) {
        this.$emit('update:selectedIndex', newIndex);
      }
    },
    selectedMethodComponentId() {
      return this.methodComponents[this.$selectedIndex].id;
    },
    isEditing() {
      return this.mode === 'edit' || this.mode === 'create';
    }
  },
  watch: {
    methodComponents: {
      handler: function (val) {
        this.$emit('onSelectedItemId', val[0].id);
      },
      deep: true
    }
  },

  mounted() {
    this.initMethodOutline();
    this.updateView();
    window.addEventListener('resize', this.updateView);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.updateView);
  },

  methods: {
    updateView() {
      this.isLargeScreen = window.innerWidth > 768;
    },
    async initMethodOutline() {
      if (this.methodComponents.length === 0) {
        this.$set(this.methodOutline, 0, {
          title: 'Introduction'
        });
      }
    },
    async addMethodOutline() {
      this.nextMethod();
      this.$emit('onAddItem', this.methodOutline);
    },
    onChangeSelectItem(index) {
      if (this.selectedIndex === index) {
        return;
      }
      const oldVal = this.selectedIndex;

      this.$emit('onSelectItem', { oldVal, newVal: index });
    },

    deleteMethod() {
      this.prevMethod();
    },
    nextMethod() {
      this.$emit('update:selectedIndex', this.$selectedIndex + 1);
    },
    prevMethod() {
      this.$emit('update:selectedIndex', this.$selectedIndex - 1);
    }
  }
};
</script>

<style lang="scss">
.container__method-component-outline {
  --bg-geadient: linear-gradient(91.61deg, #667ce8 0%, #744ba3 100%);
  --dark-primary: #3b3e66;

  max-width: 340px;
  border: 1px solid #d1d2db;
  border-radius: 12px;
  padding: 20px;

  .selected-item__method-outline {
    background: var(--bg-geadient);
    color: var(--white);
  }

  .header__method-component {
    display: flex;
    padding-bottom: 20px;
    color: var(--dark-primary);
  }

  .item__method-outline {
    font-weight: 600;
    cursor: pointer;
    border-radius: 4px;
    padding: 12px 16px;
  }

  .list__method-outline {
    margin-bottom: 0px;
    list-style-type: none;
    padding: 0;
  }
}

.button__add-method {
  margin-top: 20px;
}

// custom tooltip style
.tooltip__add-method {
  .arrow {
    border-color: #ffffff;
  }
  .tooltip-inner {
    background-color: #ffffff !important;
    max-width: 250px;
  }
}
</style>
